import script from "./PriceshowPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceshowPage.vue?vue&type=script&lang=ts&setup=true"

import "./PriceshowPage.vue?vue&type=style&index=0&id=4313b68b&lang=scss"

const __exports__ = script;

export default __exports__